<template>
  <div>
    <v-app class="custom__bg mt-1">
      <v-container>
        <v-window v-model="step">
          <!-- Step 1: Group List -->
          <v-window-item :value="1">
            <v-row>
              <!-- Left Sidebar (Profile) -->
              <v-col cols="12" md="3" lg="3">
                <v-col cols="12" class="py-1">
                  <v-card class="text-center premium-card animate-fadeInUp" max-width="300">
                    <v-card-text>
                      <v-avatar size="70" class="elevation-2" style="border: 2px solid #f69227">
                        <img :src="$root.store.getUserAvatar()" alt="Profile Picture" />
                      </v-avatar>
                      <div class="mt-3 black--text">
                        <h2 style="font-size: 17px; font-weight: 700">{{ $root.storeState.currentUser.name || 'Student' }}</h2>
                        <p style="font-size: 12px; color: #707070">{{ $root.storeState.currentUser.school || 'Not specified' }}</p>
                      </div>

                      <div class="mt-4">
                        <v-btn
                          rounded
                          block
                          height="44"
                          color="#f69227"
                          class="white--text text-capitalize hover-scale"
                          @click="step = 2"
                          elevation="2"
                        >
                          <v-icon left small>mdi-plus-circle</v-icon>
                          Create New Group
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-col>

              <!-- Main Content (Groups) -->
              <v-col cols="12" md="9" lg="9">
                <v-col cols="12" class="py-1">
                  <v-card min-height="600" class="premium-card pa-4 animate-fadeInUp delay-2">
                    <div class="d-flex align-center justify-space-between mb-6">
                      <h2 style="font-size: 20px; font-weight: 700; color: #333">Your Groups</h2>
                      <v-text-field
                        dense
                        outlined
                        rounded
                        hide-details
                        placeholder="Search groups..."
                        prepend-inner-icon="mdi-magnify"
                        color="#f69227"
                        style="max-width: 250px"
                      ></v-text-field>
                    </div>

                    <v-row>
                      <v-col cols="12" sm="6" md="4" v-for="(group, index) in myGroups" :key="index">
                        <v-card class="premium-card-elevated hover-scale fill-height d-flex flex-column" @click="chat(group.id)">
                          <v-img
                            :src="group.cover"
                            height="120"
                            class="align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.7)"
                          >
                            <v-card-title class="white--text" style="font-size: 16px; font-weight: 600; line-height: 1.2">
                              {{ group.title }}
                            </v-card-title>
                          </v-img>
                          <v-card-text class="flex-grow-1">
                            <div class="d-flex align-center justify-space-between mb-2">
                              <v-chip small color="#f0f2f5" text-color="#555" style="font-weight: 600; font-size: 11px">
                                {{ group.category }}
                              </v-chip>
                              <span class="grey--text text--darken-1 d-flex align-center" style="font-size: 12px">
                                <v-icon x-small class="mr-1">mdi-account-group</v-icon> {{ group.members }}
                              </span>
                            </div>
                            <p class="mb-0 grey--text text--darken-2" style="font-size: 13px; line-height: 1.4">
                              {{ group.description }}
                            </p>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions class="px-3 py-2 bg-light">
                            <v-avatar-group class="d-flex">
                              <v-avatar size="24" class="elevation-1" style="border: 1px solid white; margin-right: -8px" v-for="n in 3" :key="n">
                                <img :src="`https://randomuser.me/api/portraits/${n%2==0?'women':'men'}/${n+20}.jpg`" />
                              </v-avatar>
                            </v-avatar-group>
                            <v-spacer></v-spacer>
                            <span class="primary--text font-weight-medium" style="font-size: 13px; color: #f69227 !important">Open Chat &rarr;</span>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
          </v-window-item>

          <!-- Step 2: Select Members -->
          <v-window-item :value="2">
            <v-row>
              <v-col cols="12" md="4" lg="3">
                <v-col cols="12" class="py-0">
                  <v-card class="premium-card text-center mb-4" color="#f69227" dark>
                    <v-card-text class="pa-4">
                      <v-btn icon small absolute top left @click="step = 1">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <h3 style="font-weight: 600; font-size: 18px" class="mt-2">Create Group</h3>
                      <p class="mb-0 mt-1" style="font-size: 13px; opacity: 0.9">Step 1: Add members</p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card class="premium-card" max-height="550">
                    <v-card-title class="pb-0" style="font-size: 15px">Select Friends</v-card-title>
                    <v-card-text>
                      <v-text-field
                        dense outlined rounded hide-details
                        placeholder="Search..." prepend-inner-icon="mdi-magnify"
                        color="#f69227" class="mb-3 mt-2"
                      ></v-text-field>
                      
                      <v-list two-line max-height="320px" class="overflow-y-auto pa-0">
                        <v-list-item-group v-model="selected" multiple active-class="orange--text text--darken-1">
                          <template v-for="(item, idx) in friends">
                            <v-list-item :key="item.name" class="mb-1 rounded-lg">
                              <template v-slot:default="{ active }">
                                <v-list-item-action class="mr-3">
                                  <v-checkbox :input-value="active" color="#f69227"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-avatar class="ml-0">
                                  <img :src="item.image" alt="profile" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title style="font-size: 14px; font-weight: 500">{{ item.name }}</v-list-item-title>
                                  <v-list-item-subtitle style="font-size: 12px">{{ item.subtitle }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                            <v-divider :key="'div-'+idx" v-if="idx < friends.length - 1" class="my-1"></v-divider>
                          </template>
                        </v-list-item-group>
                      </v-list>

                      <div class="d-flex justify-center align-center mt-4">
                        <v-btn
                          rounded block height="44" color="#f69227"
                          class="white--text text-capitalize hover-scale"
                          @click="step = 3"
                          :disabled="selected.length === 0"
                        >
                          Next Step
                          <v-icon right small>mdi-arrow-right</v-icon>
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-col>
              <v-col cols="12" md="8" lg="9" class="hidden-sm-and-down">
                <v-card height="600" class="premium-card d-flex align-center justify-center bg-light">
                  <div class="text-center grey--text">
                    <v-icon size="64" color="grey lighten-1">mdi-account-multiple-plus-outline</v-icon>
                    <h3 class="mt-4 font-weight-medium">Select members to start</h3>
                    <p>Choose friends from the list to add them to your new group.</p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <!-- Step 3: Group Details -->
          <v-window-item :value="3">
            <v-row>
              <v-col cols="12" md="4" lg="3">
                <v-col cols="12" class="py-0">
                  <v-card class="premium-card text-center mb-4" color="#f69227" dark>
                    <v-card-text class="pa-4">
                      <v-btn icon small absolute top left @click="step = 2">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <h3 style="font-weight: 600; font-size: 18px" class="mt-2">Create Group</h3>
                      <p class="mb-0 mt-1" style="font-size: 13px; opacity: 0.9">Step 2: Group Info</p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card class="premium-card">
                    <v-card-text class="pa-4">
                      <div class="d-flex justify-center mb-4">
                        <v-avatar size="80" color="grey lighten-3" style="cursor: pointer" class="hover-scale">
                          <v-icon size="30" color="grey">mdi-camera-plus</v-icon>
                        </v-avatar>
                      </div>
                      
                      <v-text-field
                        v-model="newGroupName"
                        outlined dense rounded
                        placeholder="Group Subject/Name"
                        color="#f69227"
                        class="mb-2"
                        hide-details
                      ></v-text-field>

                      <v-textarea
                        outlined dense rounded
                        placeholder="Brief description (optional)"
                        color="#f69227"
                        rows="2"
                        class="mt-3 mb-4"
                        hide-details
                      ></v-textarea>

                      <div class="d-flex align-center justify-space-between mb-2">
                        <span style="font-size: 13px; font-weight: 600" class="grey--text text--darken-2">Selected Members ({{selected.length}})</span>
                      </div>
                      
                      <div class="d-flex flex-wrap mb-6">
                        <v-avatar size="32" class="mr-1 mb-1 elevation-1" v-for="index in selected" :key="index">
                          <img :src="friends[index].image" :title="friends[index].name" />
                        </v-avatar>
                      </div>

                      <div class="d-flex justify-center align-center">
                        <v-btn
                          rounded block height="44" color="#f69227"
                          class="white--text text-capitalize hover-scale"
                          @click="createGroup"
                          :loading="isCreating"
                          :disabled="!newGroupName || isCreating"
                        >
                          Create Group
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-col>
              <v-col cols="12" md="8" lg="9" class="hidden-sm-and-down">
                <v-card height="600" class="premium-card d-flex align-center justify-center bg-light">
                   <div class="text-center grey--text">
                    <v-icon size="64" color="grey lighten-1">mdi-image-edit-outline</v-icon>
                    <h3 class="mt-4 font-weight-medium">Name your group</h3>
                    <p>Give your study group a clear name so members know what it's about.</p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </v-container>
    </v-app>
  </div>
</template>

<script>
export default {
  data: () => ({
    step: 1,
    selected: [],
    newGroupName: "",
    isCreating: false,
    myGroups: [
      {
        id: 1,
        title: "Ahmadu Bello University - Accounting 2020",
        description: "Study group for ABU Zaria Accounting department class of 2020 alumni.",
        category: "University",
        members: 142,
        cover: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=400&h=200&fit=crop"
      },
      {
        id: 2,
        title: "JAMB Mathematics Prep",
        description: "Daily math problems and solutions for upcoming UTME exams.",
        category: "Exam Prep",
        members: 2534,
        cover: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=200&fit=crop"
      },
      {
        id: 3,
        title: "Computer Science Study Group",
        description: "Discussing algorithms, data structures, and programming concepts.",
        category: "Subject",
        members: 89,
        cover: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=200&fit=crop"
      },
      {
        id: 4,
        title: "WAEC Physics Revision",
        description: "Past questions review and conceptual understanding for physics.",
        category: "Exam Prep",
        members: 412,
        cover: "https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?w=400&h=200&fit=crop"
      }
    ],
    friends: [
      { name: "Yusuf Aliyu", subtitle: "University", image: "https://randomuser.me/api/portraits/men/22.jpg" },
      { name: "Umar Abubakar", subtitle: "Secondary", image: "https://randomuser.me/api/portraits/men/45.jpg" },
      { name: "Bello Sani", subtitle: "Tertiary", image: "https://randomuser.me/api/portraits/men/78.jpg" },
      { name: "Hafsat Yahaya", subtitle: "Primary", image: "https://randomuser.me/api/portraits/women/33.jpg" },
      { name: "Grace Okafor", subtitle: "University", image: "https://randomuser.me/api/portraits/women/65.jpg" },
      { name: "Aisha Mohammed", subtitle: "Secondary", image: "https://randomuser.me/api/portraits/women/52.jpg" },
      { name: "Ibrahim Musa", subtitle: "Tertiary", image: "https://randomuser.me/api/portraits/men/55.jpg" }
    ],
  }),
  methods: {
    chat() {
      this.$router.push("/groupchat");
    },
    createGroup() {
      this.isCreating = true;
      setTimeout(() => {
        this.isCreating = false;
        this.$root.showSnackbar("Group created successfully!", "#43a047", "mdi-check-circle");
        setTimeout(() => {
          this.chat(99); // Route to chat with dummy ID
        }, 500);
      }, 1500);
    }
  },
};
</script>

<style scoped>
.custom__bg {
  background: #f5f5f5;
}
.bg-light {
  background-color: #fafbfc !important;
}
</style>
